import { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { isNotEmpty, testEmail } from '../../shared/Utility'
import * as actions from '../../../actions'
import getText from '../../shared/i18n/labels'

// FORM
import { BwmInput } from '../../shared/form/BwmInputB5'

// BUTTONS
import { BtnFill } from '../../shared/BtnFill'

// COMPONENTS
import { PopupError } from '../../shared/popups/PopupError'
import { SimpleSpinner } from '../../shared/spinner/Spinner'
import { PopupSuccess } from '../../shared/popups/PopupSuccess'
import { AutoCompileCustom } from '../../shared/form/AutoCompileCustomB5'

export function CoraAdmin() {
  const [userLogin, setUserLogin] = useState('')
  const [fiscalCodeDeleted, setFiscalCodeDeleted] = useState('')
  const [fiscalCodeArchived, setFiscalCodeArchived] = useState('')
  const location = useLocation()

  const lang = useSelector((state) => state.language.language)
  const labels = getText(lang)

  const [isLoading, setIsLoading] = useState(false)
  const [subjectSummary, setSubjectSummary] = useState()
  const [deletedSubjects, setDeletedSubjects] = useState([])
  const [archivedSubjects, setArchivedSubjects] = useState([])

  useEffect(() => {
    handleChangeUserLogin(location?.state?.loginParam || '')
  }, [])

  const onRestoreDeleted = (userLogin, fiscalCode) => {
    let dto = {
      userLogin,
      fiscalCode
    }

    actions.restoreDeletedCoraSubject(dto).then(
      (res) => {
        PopupSuccess({
          text: `${labels.SUBJECT} "${res.completeName}" ${labels.WITH_ID} ${res.id} ${labels.RESTORED}. ${labels.REENTER_REPORTS_AND_CERTIFICATES}`
        })
      },
      (err) => {
        PopupError({ text: err.title || labels.GENERIC_ERROR })
      }
    )
  }

  const onRestoreArchived = (userLogin, fiscalCode) => {
    let dto = {
      userLogin,
      fiscalCode
    }

    actions.restoreArchivedCoraSubject(dto).then(
      (res) => {
        PopupSuccess({
          text: `${labels.SUBJECT} "${res.completeName}" ${labels.WITH_ID} ${res.id} ${labels.UNARCHIVIED}.`
        })
      },
      (err) => {
        PopupError({ text: err.title || labels.GENERIC_ERROR })
      }
    )
  }

  const handleChangeUserLogin = (value) => {
    setUserLogin(value)
    setFiscalCodeDeleted('')
    setFiscalCodeArchived('')
    setSubjectSummary(undefined)
    setDeletedSubjects([])
    setArchivedSubjects([])

    const isEmailValid = testEmail(value)
    if (isEmailValid) {
      setIsLoading(true)
      //interrogo il BE per reperire i codici fiscali ripristinabili
      actions
        .adminFindRestorableCoraSubjects(value)
        .then(
          (res) => {
            setSubjectSummary(res.subjectSummaryObject)
            setDeletedSubjects(res.deleted)
            setArchivedSubjects(res.archived)
          },
          (err) => {
            console.log(err)
          }
        )
        .then(() => setIsLoading(false))
    }
  }

  const formDropdown = (
    fiscalCode,
    onChangeFiscalCode = () => {},
    subjectList = [],
    onRestoreButtonPressed = () => {}
  ) => {
    return (
      <>
        <div className="row">
          {userLogin && (
            <div className="col-8">
              {subjectList.length > 0
                ? buildDropDown(subjectList, fiscalCode, onChangeFiscalCode)
                : 'Questo utente non ha soggetti ripristinabili'}
            </div>
          )}
          {fiscalCode && (
            <div className="row mt-3">
              <BtnFill
                text={'RIPRISTINA'}
                handlerOnClick={() => {
                  onRestoreButtonPressed()
                }}
              />
            </div>
          )}
        </div>
      </>
    )
  }

  const buildDropDown = (subjects = [], fiscalCode, setFiscalCode = () => {}) => {
    let options = subjects.map((e) => {
      return { key: e.fiscalCode, name: `${e.fiscalCode} (${e.completeName})` }
    })

    //filtro duplicati
    options = options.filter(
      (o, index, arr) =>
        arr.findIndex((item) => JSON.stringify(item) === JSON.stringify(o)) === index
    )
    return (
      <AutoCompileCustom
        label={labels.FISCAL_CODE_SUBJECT}
        id="fiscalCode"
        className="form-control"
        handleInputAutocompile={(val, id, index, key) => {
          setFiscalCode(isNotEmpty(key) ? key.trim() : val.trim())
        }}
        filter={options}
        value={fiscalCode}
      />
    )
  }

  const renderRemainingSubjects = (subjectSummary) => {
    if (subjectSummary) {
      return (
        <>
          {labels.REMAINING_SUBJECTS}: {subjectSummary.total} / {subjectSummary.used}
        </>
      )
    } else {
      return <></>
    }
  }

  return (
    <>
      <div className="row justify-content-center mt-4">
        <div className="col-6">
          <h4>{labels.RESTORE_CORA_SUBJECT}</h4>
          <div className="row mt-4">
            <div className="row">
              <div className="col-7">
                <BwmInput
                  maxLength={255}
                  label={labels.USER_LOGIN}
                  className="form-control"
                  name={'login'}
                  value={userLogin}
                  onChange={(e) => handleChangeUserLogin(e.target.value.trim())}
                />
              </div>
            </div>
            <div className="row mt-2 mb-3 align-items-center">
              <div className="col">
                <strong>{renderRemainingSubjects(subjectSummary)}</strong>
              </div>
            </div>
            {userLogin && (
              <div className="row">
                {!isLoading && (
                  <>
                    <div className="col me-1">
                      <h6>{labels.DELETED_SUBJECTS}</h6>
                      {formDropdown(fiscalCodeDeleted, setFiscalCodeDeleted, deletedSubjects, () =>
                        onRestoreDeleted(userLogin, fiscalCodeDeleted)
                      )}
                    </div>
                    <div className="col me-1">
                      <h6>{labels.ARCHIVED_SUBJECTS}</h6>
                      {formDropdown(
                        fiscalCodeArchived,
                        setFiscalCodeArchived,
                        archivedSubjects,
                        () => onRestoreArchived(userLogin, fiscalCodeArchived)
                      )}
                    </div>
                  </>
                )}
                <div className="col-1">{isLoading && <SimpleSpinner size={22} />}</div>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  )
}
